function FavManager() {

    /// <summary>
    /// This object provides client-side functions for the Widget.Collection.FavManager visual. <br/>
    /// It  creates all javascript click handler and does the server communication through the webservice
    /// <br/>
    /// Author: MWI<br />
    /// Date: 10.03.2016<br />
    /// Copyright ©: EUDT GmbH 2015 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.1 - 17.01.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - fixed Bug with wrong items shown and missing text                *<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 10.03.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    // the following attributes got set in Charts.Collection.FavManager.vb
    this.day = "";
    this.url = "";
    this.externalWidth = 420;
    this.externalHeight = 240;
}
FavManager.prototype = new window.vcTemplate();
FavManager.prototype.init = function () {
    /// <summary>
    /// This function inits the the Object <br/>
    /// it does nothing more than adding the clickhandler 
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.showInfo("", "", false);
        me.visual.find("#lstPlayer").height(me.visual.height() - 177);
        me.visual.find("#image").removeClass("error").css({ "margin-left": 0 });
        me.visual.find("#imgNote").hide();
        me.visual.find("#currentPlayerImage").vcGallery({
            mediaCategory: "TV", previewWidth: 50, previewHeight: 50, formItemWidth: 298, showDetails: true, onFileChanged: function () {
            me.savePlayerImage();
        }, onFileLoaded: function () {
            if (me.visual.find("#img_currentPlayerImage img")[0].naturalWidth < 200) {
                me.visual.find("#imgNote").show();
                me.visual.find("#image").addClass("error").css({ "margin-left": 0 });
                me.visual.find("#collFilter").width(me.visual.find("#collFilter").width() + 12);
            } else {
                me.visual.find("#imgNote").hide();
                me.visual.find("#image").removeClass("error");

            }
            }
        });
         if ((me.visual.find("#currentPlayerImage").val()).trim().length < 1 || parseInt(me.visual.find("#currentPlayerImage").val() || 10) < 1) {
             me.visual.find("#lstPlayer li").css({ "opacity": 0.4, "pointer-events": "none" });
             me.visual.find("#currentPlayerImage_mainDiv i.fa-pencil").trigger("click");
             //me.visual.find("#galPopupContent #divVCcurrentPlayerImage #divHeader").insertAfter
         }
        me.visual.find("#lstPlayer").on("click", ".vc-list-item", function () {

            me.loadDetails($(this));
        }
        );
        me.visual.find("#divBtnNewPlayer").button().on("click", function () {
            me.addNewPlayer();
        }
     );
        me.initClickHandler();

        me.visual.find(".vc-filter").vcFilter({ callback: function () { me.filter(); } });


        me.visual.find("#currentPlayerImage i.fa-times").remove();

        return true;
    } catch (ex) {
        me.writeError('FavManager.init', ex);
        return false;
    }

};
FavManager.prototype.savePlayerImage = function () {
    /// <summary>
    /// This function is called to save the logo for all players in the current project
    /// </summary>
    var me = this;
    try {
        window.VisualCoreService.updateData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, '', '', 2, 2, JSON.stringify({
            updateType: 9,
            logoid: me.visual.find("#currentPlayerImage").val()
        }), function (result) { me.savePlayerResult(result); });
        return true;
    } catch (ex) {
        me.writeError('FavManager.savePlayerImage', ex);
        return false;
    }
};
FavManager.prototype.savePlayerResult = function(result) {
    /// <summary>
    /// This function is called to save the logo for all players in the current project
    /// </summary>
    var me = this;
    try {
        var resObj = JSON.parse(result);

        me.showInfo(resObj.retHTML, "", resObj.hasError);
    } catch (ex) {
        me.writeError('FavManager.savePlayerResult', ex);
    }
};

FavManager.prototype.loadDetails = function (obj) {
    /// <summary>
    /// This function is called on click of a list element <br/>
    /// it calls the getData Webservice with the PlayerID of the clicked element <br />
    /// and then handles the display/hide of the needed elements <br/>
    /// fills the form fields, and sees that the list element is made larger
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
            window.VisualCoreService.getData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, '', '', 2, 2, JSON.stringify(me.fillPlayerObject(6, $(obj).attr("data-playerid"))),
                function (result) {
                    try {
                        var resObj = JSON.parse(result);
                        me.visual.find("#player, #favManagerOpt").hide();
                        me.visual.find("#playerNew").html(resObj.retHTML).show();
                        me.visual.find("#ddlType").val(resObj.retPlayer.type);
                        me.visual.find("#txtName").val(resObj.retPlayer.Name);
                        me.visual.find("#txtDesc").val(resObj.retPlayer.Description);
                        me.visual.find("#ddlFavor" + $(obj).attr("data-playerid"))
                            .val(resObj.retPlayer.mainFavoritesID);
                        me.visual.find("#ddlFavorSub" + $(obj).attr("data-playerid"))
                            .val(resObj.retPlayer.subFavoritesID);

                        me.visual.find("#ddlTheme").val(resObj.retPlayer.themeID);
                        me.visual.find("#ddlMaster").val(resObj.retPlayer.masterID);

                        me.initDetailForm($(obj).attr("data-playerid"));
                    } catch (ex) {
                        me.writeError('FavManager.loadDetails', ex);
                        return false;

                    }
                    return true;
                });
        return true;
    } catch (ex) {
        me.writeError('FavManager.loadDetails', ex);
        return false;
    }
};

FavManager.prototype.initSizeSelector = function () {
    /// <summary>
    /// This function initializes the toggle selector for the size of the iframe
    ///</summary>
    var me = this;
    try {
        if (me.error) {
            return;
        }
        me.visual.find("label").on("click", function() {

                me.visual.find(".chbSize").each(function() {
                    $(this).attr("checked", false);
                });

                me.visual.find(".chbSize").off("click").on("click", function() {
                    me.setComparison();
                    me.visual.find("#prev").css({ "height": me.externalHeight, "width": me.externalWidth }).attr("src", me.url);

                });
                me.visual.find("#" + $(this).attr("for")).attr("checked", true);
                me.setComparison();
            }
        );
        me.setComparison();
    } catch (ex) {
        me.writeError('FavManager.initSizeSelector', ex);

    }
};

FavManager.prototype.setComparison = function () {
    /// <summary>
    /// This function sets the selected comparison settings.
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return;
        }
        if (me.visual.find("#chbSizeSmall").is(":checked")) {
            me.visual.find("#divMed,#divLarge,#divCust").hide();
            me.externalWidth = 420;
            me.externalHeight = 240;
            me.visual.find("#divSmall").show();

        }
        if (me.visual.find("#chbSizeMed").is(":checked")) {
            me.visual.find("#divSmall,#divLarge,#divCust").hide();
            me.externalWidth = 630;
            me.externalHeight = 360;
            me.visual.find("#divMed").show();

        }
        if (me.visual.find("#chbSizeLarge").is(":checked")) {
            me.visual.find("#divSmall,#divMed,#divCust").hide();
            me.externalHeight = 480;
            me.externalWidth = 840;
            me.visual.find("#divLarge").show();

        }
        me.setExternalSizes();

    } catch (ex) {
        me.writeError('FavManager.js.setComparison', ex);

    }
};

FavManager.prototype.addNewPlayer = function () {
    /// <summary>
    /// Provides the Clickhandler to add a new Player/External/Webplayer <br/>
    /// opens a popup as overlay for the settings <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.showInfo("", "", false);
        //me.showDevIcon("beta");
        me.visual.find("#lstHeader, #lstPlayer, #favManagerOpt").hide();
        me.visual.find('.detail').html("");
        window.VisualCoreService.getData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, '', '', 2, 2, JSON.stringify(me.fillPlayerObject(6, -1)),
            function (result) {
                var resObj = JSON.parse(result);
                me.visual.find("#playerNew").html(resObj.retHTML).show();
                me.initDetailForm(-1);
            });
        return true;
    } catch (ex) {
        me.writeError('addNewPlayer', ex);
        return false;
    }
};

FavManager.prototype.getKey = function () {
    /// <summary>
    /// This function retrieves the key from the server <br/>
    /// therefore it connects through the webservice and retrieves the result
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        window.VisualCoreService.getData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, '', '', 2, 2, JSON.stringify(me.fillPlayerObject(1)),
            function(result) {
                var resObj = JSON.parse(result);
                me.showInfo(resObj.retHTML, "", resObj.hasError);
            });
    } catch (ex) {
        me.writeError('getKey', ex);

        return false;
    }
    return false;
};

FavManager.prototype.initDetailForm = function (plID) {
    /// <summary>
    /// This function retrieves the key from the server <br/>
    /// therefore it connects through the webservice and retrieves the result
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.visual.find("#divBtnFavManDetailSave").button().on("click", function () {
            window.VisualCoreService.updateData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, '', '', 2, 2, JSON.stringify(me.fillPlayerObject(5, plID)), function (res) { me.fillPlayerList(res); });
            me.visual.find("#divBtnFavManDetailBack").trigger("click");

        });

        me.initSizeSelector();
        //me.checkForm();
        me.visual.find("#divBtnFavManDetailBack").button().on("click", function () { me.btnBack(); }).show();

        me.visual.find('#txtName').on("keydown, keyup", function () {
            me.checkForm();
        });
        if (plID !== -1) {
            if (parseInt(me.visual.find("#ddlType").val(), 10) === 1) {
                me.visual.find("#div-sel-size").css({"opacity":"0.4", "pointer-events":"none", "cursor":"not-allowed"});
            }
            me.visual.find("#ddlType").attr("disabled", true);
            me.visual.find('#divKeyHtml').on("click", function () {
                $(this).select();
            });
            me.visual.find('#prev').off("load").on("load", function() {
                me.visual.find('#prev')[0].contentWindow.postMessage({
                    msg: "SET_VALUES",
                    val: {
                        "mainid": me.visual.find(".ddl.fav[data-type='main']").val(),
                        "subid": me.visual.find(".ddl.fav[data-type='sub']").val(),
                        "masterID": me.visual.find("#ddlMaster").val(),
                        "themeID": me.visual.find("#ddlTheme").val()
                    }
                 }, "*");
            });
            window.VisualCoreService.getData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, '', '', 2, 2, JSON.stringify(me.fillPlayerObject(3, plID)),
                function (result) {
                    var resObj = JSON.parse(result);

                    if (parseInt(me.visual.find("#ddlType").val(), 10) === 2) {
                        me.url = resObj.retHTML;
                        me.setExternalSizes();
                    } else {
                        me.visual.find('#divKeyHtml').html(resObj.retPlayer.key);
                    }
                    me.visual.find('#prev').attr('src', resObj.retHTML);
                    $(window).on("resize", function () {
                        me.visual.find('#prev').attr('src', resObj.retHTML);
                    });
                

                    me.visual.find('#btnPlay').on("click", function () {
                        if (me.running === true) {
                            me.running = false;
                            me.visual.find('#prev')[0].contentWindow.location.reload(false);
                            $(this).find(".fa.fa-pause-circle").removeClass("fa-pause-circle").addClass("fa-play-circle");

                        } else {
                            me.running = true;
                            //me.visual.find('#prev')[0].contentWindow.postMessage({ msg: "CHANGE_PLAYLIST", val: { ) } }, "*");

                            me.visual.find('#prev')[0].contentWindow.postMessage({ msg: "START", val: me.visual.find('#ddlMaster').val() }, "*");
                            $(this).find(".fa.fa-play-circle").removeClass("fa-play-circle").addClass("fa-pause-circle");
                        }
                    });
                });
            me.visual.find('#ddlMaster').on("change", function () {
                me.visual.find('#prev')[0].contentWindow.postMessage({ msg: "HANDLER_SETMASTER", val: $(this).val() }, "*");
            });
            me.visual.find('#ddlTheme').on("change", function () {
                me.visual.find('#prev')[0].contentWindow.postMessage({ msg: "HANDLER_SETTHEME", val: $(this).val() }, "*");
            });
            me.visual.find('.ddl.fav').on("change", function () {
                me.visual.find('#prev')[0].contentWindow.postMessage({ msg: "CHANGE_PLAYLIST", val: { "mainid": me.visual.find(".ddl.fav[data-type='main']").val(), "subid": me.visual.find(".ddl.fav[data-type='sub']").val() } }, "*");
            });
            me.visual.find(".ddl").chosen({"inherit_select_classes":true, "allow_single_deselect":true,"width":"70%"});
            me.visual.find('#txtName, .ddl.fav').on("change", function () {
                me.checkForm();
            });
        } else {
            me.visual.find(".vc-wizard .vc-wizard-step.done").html($(".infopanel.caption div:first-child").html().split("@")[1].trim());
            //me.visual.find(".vc-wizard .vc-wizard-step.open").html(me.resources.newPlayer);
            me.visual.find(".ddl").chosen({ "inherit_select_classes": true, "allow_single_deselect": true, "width": "70%" });

            me.visual.find("#prev, .collKey, #list-favman-header").hide();
            me.visual.find("#favManPreview").append(me.resources.noPreviewBeforeFirstSaving);
            me.visual.find("#favManPreview").append(me.resources.firstHelp);

        }
        return true;
    } catch (ex) {
        me.writeError('FavManager.initDetailForm', ex);
        return false;
    }
};

FavManager.prototype.htmlEntities = function (str) {
    /// <summary>
    /// This function replaces some special html characters to their html counterpart <br/>
    /// e.g. & gets &amp;
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    } catch (ex) {
        me.writeError('FavManager.htmlEntities', ex);
        return false;
    }
};

FavManager.prototype.setExternalSizes = function () {
    /// <summary>
    /// This function prepares the html string containing the iframe for external playlists <br/>
    /// it uses the internal variables externalWidth, externalHeight and url to build the complete string <br/>
    /// the rest of the html is pretty much hardcoded
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return;
        }
        me.visual.find('#divKeyHtml').html(me.htmlEntities("<iframe src='" + me.url + "' sandbox='allow-popups allow-same-origin allow-scripts' width='" + me.externalWidth.toString() + "' height='" + me.externalHeight.toString() + "'></iframe>"));
    } catch (ex) {
        me.writeError("FavManager.setExternalSizes", ex);
    } return;

};

FavManager.prototype.btnBack = function () {
    /// <summary>
    /// Handles the click of the back button <br/>
    /// removes the content of the player New and <br/>
    /// list again
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return;
        }
        me.visual.find('#favManagerOpt, #player, #list-favman-header, #lstPlayer').show();
        me.visual.find('#playerNew').html("").hide();
        me.filter();
    } catch (ex) {
        me.writeError('FavManager.btnBack', ex);
    } return;
};

FavManager.prototype.checkForm = function () {
    /// <summary>
    /// This function checks the input form if it is valid and the needed fields are set <br/>
    /// if not it disables the save button <br/>
    /// the rest of the html is pretty much hardcoded
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        if (me.visual.find("#txtName").val().trim() === "") {
            me.visual.find("#divBtnFavManDetailSave").button({ disabled: true });
        } else {
            me.visual.find("#divBtnFavManDetailSave").button({ disabled: false });
        }
    } catch (ex) {
        me.writeError('FavManager.checkForm', ex);

    }
    return false;
};

FavManager.prototype.fillPlayerObject = function(upType, playerid, name) {
    /// <summary>
    /// creates the  objects with the information about the plyer
    /// </summary>

    var me = this;

    try {
        if (me.error) {
            return false;
        }
        if (typeof name === 'undefined') {
            name = me.visual.find("#txtName").val();
        }
        if (typeof playerid === 'undefined') {
            playerid = $(this).attr("data-playerid").val();
        }

        var saveObj = {
            updateType: upType,
            name: name,
            description: me.visual.find("#txtDesc").val(),
            type: me.visual.find("#ddlType option:selected").val(),
            playerID: playerid,
            mainFavoritesID: me.visual.find("#ddlFavor" + playerid).val(),
            subFavoritesID: me.visual.find("#ddlFavorSub" + playerid).val(),
            themeID: me.visual.find("#ddlTheme option:selected").val(),
            masterID: me.visual.find("#ddlMaster option:selected").val()
        };
        return saveObj;
    } catch (ex) {
        me.writeError('FavManager.fillPlayerObject', ex);
    }
    return false;
};

FavManager.prototype.initClickHandler = function() {
    /// <summary>
    /// initializes the clickhandler for the tasks 
    /// </summary>
    var me = this;
    try {
        //task0 = show preview
        me.visual.find("#lstPlayer  .col0").on("click",
            function(event) {
                event.stopPropagation();
            });

        //task1 = restart windows
        me.visual.find("#lstPlayer  .task1").on("click",
            function(event) {
                event.stopPropagation();
                me.sendTask("task1", $($(event.delegateTarget).parents(".vc-list-item")).attr("data-playerid"));

            }
        );

        //task3 = delete player
        me.visual.find("#lstPlayer .task3").on("click",
            function(event) {
                event.stopPropagation();
                me.del($($(event.delegateTarget).parents(".vc-list-item")).attr("data-playerid"));
            }
        );
    } catch (ex) {
        me.writeError('FavManager.initClickHandler', ex);
        return false;
    }
    return false;
};

FavManager.prototype.fillPlayerList = function (result) {
    /// <summary>
    /// function to uniformly fill the list with players <br/>
    /// </summary>
    ///<param type='Object' name='result'>This object contains all relevaint information for the player</param>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        var resObj = JSON.parse(result);
        me.visual.find('#lstPlayer').empty().append(resObj.retHTML).ready(function() {
                if (resObj.retID !== -1) {
                    me.visual.find(".vc-list-item[data-playerid='" + resObj.retID + "']").trigger("click");
                    //$('html, body').animate({ scrollTop: me.visual.find("#lstPlayer .tblBody[data-playerid='" + resObj.retID + "']").offset().top, duration: 1000 });
                }
            })
            .show();
        me.initClickHandler();
        me.visual.find('#lstHeader').show();
        me.visual.find('#playerNew').html("").hide();
    } catch (ex) {
        me.writeError('FavManager.fillPlayerList', ex);

    }
    return false;

};

FavManager.prototype.filter = function () {
    /// <summary>
    /// This function adds/removes two css-classes ('found' and 'exclude') for filtering loggers.<br/>
    /// When a logger with a filter expression gets found the 'found' class gets added - and the other way round for the 'exclude' class. <br/>
    /// At the end, basically all 'found' classes get shown and all 'exclude' classes get hidden - the favorites state gets considered as well.<br/>
    /// </summary>
    /// <summary>
    /// This function filters the entries based on a given filter and filters the complete content of the list based on the vcFilter  <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        //hide all
        me.visual.find(".vc-list-table .vc-list-item").removeClass("found").data("counterfound", 0).hide();
        //me.visual.find("#col1.vc-filter, #col2.vc-filter, #col3.vc-filter, #col4.vc-filter").trigger("change");

        //we add the 'found' class to all items we want to filter based on the vcfilter tags
        me.setTagFilter(".vc-filter", ".vc-list-table .vc-list-item", "found");
        me.visual.find(".vc-list-table .vc-list-item.found").show();
        me.visual.find(".vc-list-table .vc-list-item").removeClass("alt");
        me.visual.find(".vc-list-table .vc-list-item.found:even").addClass("alt");

        return true;
    } catch (ex) {
        me.writeError('ProjectOverview.filter', ex);
        return false;
    }
};
FavManager.prototype.setTagFilter = function (filterObj, listItem, classFound) {
    /// <summary>
    /// This function takes all tags from the vcFilter widget (filterObj) and adds a 'classFound' css class to all entries it founds in 'listItem'.<br/>
    /// It is used as part of the filter function in vc-lists
    /// </summary>
    var me = this;
    var countertext;
    try {
        countertext = "counterfound";
        //we reset the counter for found entries
        me.visual.find(listItem).data(countertext, 0);

        //we filter the optional tags we got from the vc-tags
        var filter = me.visual.find(filterObj).vcFilter("getFilter");

        if (filter !== null) {
            var counter;
            //first, we count how often we find the filter tags in every signal item
            for (var i = 0; i <= filter.length - 1; i++) {
                if (filter[i].length > 0) {
                    me.visual.find(listItem + ":contains('" + filter[i] + "')")
                        .each(function () {
                            counter = parseInt($(this).closest(".vc-list-item").data(countertext), 10);
                            if (isNaN(counter)) {counter = 0; }
                            counter++;
                            $(this).closest(".vc-list-item").data(countertext, counter);
                        });
                }
            }

            //if we found them as often as the number of filter tags - we are the lucky winner and show the entry!!
            //why? if we have several filter tags we have to find all of them in one single signal 
            me.visual.find(listItem)
                .each(function () {
                    if (parseInt($(this).data(countertext), 10) === filter.length) {
                        $(this).addClass(classFound);
                    }
                });
        } else {

            me.visual.find(listItem).addClass(classFound);
        }
    } catch (ex) {
        me.writeError(me.source + '.JS.setTagFilter', ex);
    }
};

//FavManager.prototype.addFilter = function () {
//    /// <summary>
//    /// As the name says this adds the event to the filter div <br/>
//    /// </summary>
//    var me = this;
//    var bRet = true;
//    try {
//        if (me.error) {
//            bRet = false;
//        } else {
//            me.visual.find(".txt-filter,.chb-filter").off('change keydown keyup').on('change keydown keyup', function () {
//                me.filter();
//            });
//        }
//    } catch (ex) {
//        me.writeError("FavManager.addFilter", ex);
//        bRet = false;
//    }
//    return bRet;
//};

//FavManager.prototype.filter = function () {
//    /// <summary>
//    /// This function handles the entry filtering.
//    /// </summary>
//    var me = this;
//    try {
//        if (me.error) {
//            return false;
//        }
//        //remove all filter
//        me.visual.find('.vc-list-table .vc-list-item').removeClass("foundcol1  foundcol2 foundcol3 foundcol4 foundcol5 alt");
//        if (me.visual.find("#chbFiltercol1").prop('checked')) {
//            me.visual.find(".vc-list-item .col1 .fa-check").parents(".vc-list-item").addClass("foundcol1");
//        } else {
//            me.visual.find(" .vc-list-item .col1").parents(".vc-list-item").addClass("foundcol1");
//        }
//        me.visual.find(".txtEnabled.txt-filter").each(function () {
//            me.splitFilter($(this).val().trim(), $(this).data("col"));
//        });

//        me.visual.find(".vc-list-table .vc-list-item").not(".foundcol1.foundcol2.foundcol3.foundcol4.foundcol5").hide();
//        me.visual.find(".vc-list-table  .vc-list-item.foundcol1.foundcol2.foundcol3.foundcol4.foundcol5").show().filter(":even").addClass("alt");
//        return true;
//    } catch (ex) {
//        me.writeError('reportOverview.filter', ex); return false;
//    }
//};

//FavManager.prototype.splitFilter = function (val, col) {
//    /// <summary>
//    /// This function splits a single filter input and finds all entries which contain the filter expression.
//    /// </summary>
//    var me = this;
//    var filter;
//    var i;
//    try {
//        if (me.error) {
//            return false;
//        }
//        //get filter expressions
//        filter = val.trim();
//        if (filter.length > 0) {
//            filter = filter.split(" ");
//            for (i = 0; i < filter.length; i++) {
//                if (filter[i].length > 0) {
//                    me.visual.find(".vc-list-table  .vc-list-item").has("." + col + ":contains('" + filter[i] + "')").addClass("found" + col);
//                    me.visual.find(".vc-list-table  .vc-list-item ").has("." + col + " div[title*='" + filter[i] + "']").addClass("found" + col);
//                }
//            }
//        } else {
//            me.visual.find(".vc-list-table  .vc-list-item").addClass("found" + col);
//        }

//        return true;
//    } catch (ex) {
//        me.writeError('FavManager.splitFilter', ex); return false;
//    }
//};

FavManager.prototype.sendTask = function (task, playerid) {
    /// <summary>
    /// Provides the Clickhandler to add a new Player/External/Webplayer <br/>
    /// opens a popup as overlay for the settings <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.showInfo("", "", false);
        window.VisualCoreService.updateData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, '', '', 2, 2, JSON.stringify(me.fillPlayerObject(7, playerid, task)),
            function (result) {
                var resObj = JSON.parse(result);
                me.showInfo(resObj.retHTML, "", resObj.hasError);
            });
        return true;
    } catch (ex) {
        me.writeError('FavManager.addNewPlayer', ex);
        return false;
    }
};

FavManager.prototype.del = function (playerid) {
    /// <summary>
    /// Provides the Clickhandler to add a new Player/External/Webplayer <br/>
    /// opens a popup as overlay for the settings <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.showInfo("", "", false);
        window.VisualCoreService.updateData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, '', '', 2, 2, JSON.stringify(me.fillPlayerObject(8, playerid,"")), function (result) {
            me.fillPlayerList(result);
        });
        return true;
    } catch (ex) {
        me.writeError('FavManager.delete', ex);
        return false;
    }
};
